module.exports = __webpack_public_path__ + "static/media/banjo.23a47896.svg";